import React from 'react';
import {
  FDStack, FDBodyText, FDTooltip,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import HouseholdInfoSectionAvatarPicker from '../HouseholdInfoSectionAvatarPicker/HouseholdInfoSectionAvatarPicker';

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['name'], {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride(['age', 'relation'], {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly);

const HouseholdInfoSectionFamilyMember = ({ resource }) => {
  return (
    <FDStack alignItems={'center'} spacing={1} key={resource.id()}>
      <HouseholdInfoSectionAvatarPicker resource={resource} size={'sm'} />
      <FDStack spacing={1} alignItems={'center'}>
        <MetaControl attrName={'name'} metaOverrideSet={metaOverride} resource={resource} />
        <FDTooltip title={resource.attr('birthDate')}>
          <FDBodyText value={resource.attr('age')} size={'sm'} />
        </FDTooltip>
        <FDBodyText size={'sm'} value={'-'} />
        <MetaControl attrName={'relation'} metaOverrideSet={metaOverride} resource={resource} />
      </FDStack>
    </FDStack>
  );
};

HouseholdInfoSectionFamilyMember.defaultProps = {};

HouseholdInfoSectionFamilyMember.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default HouseholdInfoSectionFamilyMember;
